import {InjectionToken} from "@angular/core";
import {IQrCodeModalService} from "./i-qr-code-modal.service";

export const qrCodeModalServiceInjectionToken: InjectionToken<IQrCodeModalService> =
  new InjectionToken<IQrCodeModalService>("qrCodeModalServiceInjectionToken");
